import { render } from "./ListeTypeNotificationPage.vue?vue&type=template&id=5224f6b0&ts=true"
import script from "./ListeTypeNotificationPage.vue?vue&type=script&lang=ts"
export * from "./ListeTypeNotificationPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__